import { createContext, useMemo, useState } from 'react'

export const StepperContext = createContext({
  currentStep: 0,
  nbSteps: 4,
  previousDisabled: true,
  nextDisabled: true,
  isPreviousMove: false,
  setCurrentStep: (step: number) => {},
  previousPage: () => {},
  nextPage: () => {},
  setPreviousDisabled: (disabled: boolean) => {},
  setNextDisabled: (disabled: boolean) => {},
  setIsPreviousMove: (isIt: boolean) => {}
})

export const StepperProvider = (props: any) => {
  const nbSteps = 4 // index 0 based
  const [currentStep, setCurrentStep] = useState(0)
  const [isPreviousMove, setIsPreviousMove] = useState(false)
  const [previousDisabled, setPreviousDisabled] = useState(true)
  const [nextDisabled, setNextDisabled] = useState(true)
  const mainContainer = document.getElementsByClassName('main-container')[0]

  const previousPage = () => {
    setCurrentStep(prevActiveStep => prevActiveStep - 1)
    setPreviousDisabled(true)
    setNextDisabled(true)
    setIsPreviousMove(true)
    scrollToTop()
  }

  const nextPage = () => {
    setCurrentStep(prevActiveStep => prevActiveStep + 1)
    setPreviousDisabled(false)
    setNextDisabled(true)
    setIsPreviousMove(false)
    scrollToTop()
  }

  const scrollToTop = () => {
    mainContainer.scrollIntoView(true)
  }

  const values = useMemo(
    () => ({
      nbSteps,
      currentStep,
      setCurrentStep,
      nextPage,
      previousPage,
      previousDisabled,
      nextDisabled,
      setNextDisabled,
      setPreviousDisabled,
      isPreviousMove,
      setIsPreviousMove
    }),
    [currentStep, previousDisabled, nextDisabled]
  )

  return <StepperContext.Provider value={values}>{props.children}</StepperContext.Provider>
}
